import axiosApiInstance from './request';
const apiVersion = 'v2';
const getAdminClientRecordService = async (params: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get('/admin-clients/', { headers, params });
  } catch (error: any) {
    response = error;
  }
  return response;
};
const getAdminCoderRecordService = async (params: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get('/admin-coders/', { headers, params });
  } catch (error: any) {
    response = error;
  }
  return response;
};
const patchAdminCoderRecordService = async (payload: any, Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.patch(`/admin-coders/${Id}/`, payload, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const patchAdminClientRecordService = async (payload: any, Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.patch(`/admin-clients/${Id}/`, payload, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getAdminJobRecordByIdService = async (Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/admin-jobs/${Id}/`, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getAdminJobRecordService = async (params: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get('/admin-jobs/', { headers, params });
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getAdminProposalRecordService = async (params: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get('/admin-proposal/', { headers, params });
  } catch (error: any) {
    response = error;
  }
  return response;
};

const coderProfileDataByIdService = async (coderId: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.get('/admin-coders/' + coderId + '/', { headers });
    response = res;
  } catch (error) {
    response = error;
  }
  return response;
};
const getAdminDisputesService = async (params: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get('/raise-job-dispute/', { headers, params });
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getAdminDisputeByIdService = async (id: string) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/raise-job-dispute/${id}/`, { headers });
  } catch (error: any) {
    response = error;
  }
  return response;
};
const putAdminDisputeByIdService = async (id: string, payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.put(`/raise-job-dispute/${id}/`, payload, { headers });
  } catch (error: any) {
    response = error;
  }
  return response;
};
const postAdminDisputeCommentService = async (payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.post(`/dispute-comment/ `, payload, { headers });
  } catch (error: any) {
    response = error;
  }
  return response;
};
const getTimesheetRecordByAdminService = async (id: any, params: any) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  let response = {};
  try {
    response = await axiosApiInstance.get(`/update-timesheet/${id}/`, {
      headers,
      params,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const getMilestoneRecordByAdminService = async (params: any) => {
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.get(`/admin-milestone/`, {
      headers,
      params
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const putMilestoneRecordByAdminService = async (id: any, payload: any) => {
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.put(`/admin-milestone/${id}/`, payload, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
export {
  getAdminClientRecordService,
  getAdminCoderRecordService,
  getAdminJobRecordService,
  getAdminProposalRecordService,
  coderProfileDataByIdService,
  patchAdminCoderRecordService,
  patchAdminClientRecordService,
  getAdminJobRecordByIdService,
  getAdminDisputesService,
  getAdminDisputeByIdService,
  putAdminDisputeByIdService,
  postAdminDisputeCommentService,
  getTimesheetRecordByAdminService,
  getMilestoneRecordByAdminService,
  putMilestoneRecordByAdminService
};
